export const onfidoPhrasesNlNL = {
    back: 'Vorige',
    capture: {
        driving_licence: {
            front: {
                title: 'Voorkant',
                instructions: 'Upload de voorkant van je rijbewijs',
                webcam: 'Plaats de voorkant van je rijbewijs in het frame (het wordt automatisch herkend)',
            },
            back: {
                title: 'Achterkant',
                instructions: 'Upload de achterkant van je rijbewijs',
                webcam: 'Plaats de achterkant van je rijbewijs in het frame (het wordt automatisch herkend)',
            },
        },
        face: {
            title: 'Neem een selfie',
            help: 'Problemen? Upload hier een selfie',
            button: 'Neem selfie',
            webcam: 'Plaats je gezicht in de ovaal',
            instructions: 'Neem een selfie van je volledige gezicht',
            upload_title: 'Controleer selfie',
        },
        document: {
            help: 'Problemen? Upload een bestand',
        },
    },
    capture_parentheses: '(Of sleep een bestand hiernaartoe)',
    driving_licence: 'Start met het uploaden van je rijbewijs',
    cross_device: {
        intro: {
            document: {
                title: 'Ga verder met verificatie op je mobiel',
                take_photos: "We helpen je foto's nemen met je mobiel",
                action: 'Nummer opgeven',
            },
            face: {
                title: 'Ga verder met een selfie nemen via je mobiel',
                take_photos: 'We nemen een selfie om overeenkomst met je rijbewijs vast te stellen',
                action: 'Doorgaan',
            },
            sub_title: 'Het is snel, simpel en veilig',
            sms: 'We sturen een SMS met een link naar je mobiel (geen download nodig)',
            return_computer: 'Hierna gaan we verder op je computer met de verificatie',
            upload_file: 'Upload foto',
            take_photo: 'Neem foto',
        },
        switch_device: {
            header: "Gebruik je smartphone om foto's te uploaden",
            submessage: 'Ga veilig verder met de verificatie vanaf je smartphone',
        },
        link: {
            title: 'Ga verder met de verificatie vanaf je mobiele telefoon',
            sub_title: 'Er wordt een eenmalige link naar je smartphone verzonden',
            copy_link_label: 'Of kopieer de link:',
            link_copy: {
                action: 'Kopieer',
                success: 'Gekopieerd',
            },
            sms_label: 'Telefoonnummer',
            button_copy: {
                action: 'Verzend link',
                status: 'Verzonden',
            },
        },
        mobile_connected: {
            title: {
                message: 'Verbonden met je mobiele telefoon',
                submessage: 'Wanneer je klaar bent, nemen we je mee naar de volgende stap',
            },
            tips: {
                item_1: 'Houd dit venster open tijdens het uploaden',
                item_2: 'De mobiele link verloopt na één uur',
                item_3: 'Ververs dit venster niet',
            },
        },
        mobile_notification_sent: {
            title: 'Controleer je telefoon',
            submessage: 'We hebben een veilige link verzonden naar %{number}',
            bold_message: 'Het kan enkele minuten duren',
            tips: {
                item_1: 'Houd dit venster open tijdens het uploaden',
                item_2: 'De mobiele link verloopt na één uur',
            },
            resend_link: 'Verzend link opnieuw',
        },
        client_success: {
            title: 'Het is gelukt!',
            sub_title: 'Je kan nu verder met de verificatie',
            body: 'Het kan een moment duren voordat de wijzingen zichtbaar zijn',
        },
        loading: 'Bezig met laden...',
        phone_number_placeholder: 'Vul je telefoonnummer in',
        submit: {
            title: 'Perfect! Dat is alles wat we nodig hebben',
            sub_title: 'We kunnen nu je identiteit verifiëren',
            selfie_uploaded: 'Je selfie is geupload',
            one_doc_uploaded: 'Je document is geupload',
            multiple_docs_uploaded: 'Je documenten zijn geupload',
            action: 'Ga verder',
        },
    },
    confirm: {
        confirm: 'Bevestig',
        redo: 'Opnieuw',
        continue: 'Ga verder',
        document: {
            title: 'Leesbaarheid',
        },
        driving_licence: {
            message: 'Zorg dat de details duidelijk te lezen zijn',
        },
        face: {
            message: 'Controleer of je volledige gezicht in beeld is',
        },
    },
    complete: {
        message: 'De verificatie is compleet',
        submessage: 'Bedankt!',
    },
    document_selector: {
        title: 'Verifieer je rijbewijs',
        hint: 'Het verifiëren van je rijbewijs duurt enkele minuten. Klik op de knop hieronder om verder te gaan',
    },
    welcome: {
        next_button: 'Verifieer je identiteit',
    },
    errors: {
        lazy_loading: {
            message: 'Er ging iets mis bij het laden',
        },
        sms_overuse: {
            message: 'Er zijn teveel pogingen om te verzenden gedaan',
            instruction: 'Kopieer de link naar je smartphone',
        },
        sms_failed: {
            message: 'Er ging iets mis',
            instruction: 'Kopieer de link naar je smartphone',
        },
        server_error: {
            message: 'Geen verbinding',
            instruction: 'Probeer het opnieuw',
        },
        generic_client_error: {
            message: 'Er ging iets mis',
            instruction: 'Start de verificatie procedure opnieuw',
        },
        invalid_size: {
            message: 'Het bestand is te groot',
            instruction: 'Het bestand mag niet groter zijn dan 10MB',
        },
        multiple_faces: {
            message: 'Er zijn meerdere gezichten gevonden',
            instruction: 'Alleen je eigen gezicht mag zichtbaar zijn',
        },
        unsupported_file: {
            message: 'Het bestandstype wordt niet ondersteund',
            instruction: 'Probeer een .jpg of .png bestand',
        },
        no_face: {
            message: 'Geen gezicht gevonden',
            instruction: 'Zorg dat je gezicht zichtbaar is',
        },
        invalid_type: {
            message: 'Bestand is niet aan het uploaden',
            instruction: 'Probeer een ander bestandstype',
        },
        glare_detected: {
            message: 'Verblindend licht gedetecteerd',
            instruction: 'Controleer of alle gegevens duidelijk leesbaar zijn',
        },
        invalid_capture: {
            message: 'Geen document gevonden',
            instruction: 'Zorg ervoor dat het volledige document in beeld is',
        },
        invalid_number: {
            message: 'Controleer het telefoonnummer',
        },
    },
}
